export const PAGE_SIZES = [25, 50, 100];

/** Reads a positive page number and a supported page size from URL params. */
export function readPaging(params: URLSearchParams): { page: number; size: number } {
  const page = Number(params.get('page'));
  const size = Number(params.get('size'));
  return {
    page: Number.isInteger(page) && page > 0 ? page : 1,
    size: PAGE_SIZES.includes(size) ? size : 25,
  };
}
